import React from 'react';

import { Icon, IconBus, IconKebab, IconTrain } from '@flixbus/honeycomb-icons-react';
import { Box, Tag } from '@flixbus/honeycomb-react';

import Deliniator from 'common/Deliniator';
import StatusIcon from 'common/StatusIcon';
import { getTagAppearanceProp } from 'utils/assigmentStatusToTagVariant';

import { buildDeadheadRowData } from './buildDeadheadRowData';
import { DEADHEAD_ITEM_TEXT } from './texts';

import styles from './styles.module.css';

/**
 * @typedef {import('./buildDeadheadRowData').DeadheadInput} DeadheadInput
 * @typedef {import('./buildDeadheadRowData').TimezoneSelection} TimezoneSelection
 */

/**
 * @param {{ rideDetails: DeadheadInput, timezone: TimezoneSelection }} props
 */
export default function DeadheadItem({ rideDetails, timezone }) {
	// TODO: REPLACE WITH REAL DATA
	const vehicleTypeBus = 1;

	const {
		rideNumber,
		type,
		busLabel,
		crewMemberName,
		routeLabel,
		departureLabel,
		statusVisualKey,
		statusLabel,
	} = buildDeadheadRowData({ deadhead: rideDetails, timezone });

	return (
		<Box extraClasses={styles.item}>
			<div className={styles.rideInfoWrapper}>
				<strong>{DEADHEAD_ITEM_TEXT.scheduleLabel}</strong>
				<div className={styles.rideNumber}>{rideNumber}</div>
			</div>

			<div className={styles.center}>
				<div className={styles.stationsInfo}>
					<div className={styles.stationsContentLeft}>
						<div className={styles.route}>{routeLabel}</div>
						<div className={styles.departure}>{departureLabel}</div>
					</div>
					<div className={styles.stationsContentRight}>
						<Deliniator />
						<div className={styles.stationsContentRightWrapper}>
							<div className={styles.metaItem}>
								<strong>{DEADHEAD_ITEM_TEXT.typeLabel}</strong> {type}
							</div>
							<div className={styles.metaItem}>
								<Tag display="outlined">
									<Icon InlineIcon={vehicleTypeBus ? IconBus : IconTrain} />
									{busLabel}
								</Tag>
							</div>
						</div>
					</div>
				</div>

				<Box extraClasses={styles.crewMemberWrapper}>
					<div className={styles.crewMemberInfo}>
						<div>
							{DEADHEAD_ITEM_TEXT.crewMemberLabel} <strong>{crewMemberName}</strong>
						</div>
						<Tag small {...getTagAppearanceProp(statusVisualKey)}>
							<StatusIcon status={statusVisualKey} />
							{statusLabel}
						</Tag>
					</div>
					<Icon InlineIcon={IconKebab} />
				</Box>
			</div>
		</Box>
	);
}
